var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-layout" },
    [
      _c("dashboard-header"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "dashboard-wrapper" } },
        [
          _c("dashboard-sidebar"),
          _vm._v(" "),
          _c("div", { attrs: { id: "dashboard-content" } }, [_c("child")], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-239b7900", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239b7900","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/dashboard.vue
// module id = 410
// module chunks = 19